var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isWebComponentReady)?_c('nomad-operator-chat',{ref:"chatOperatorRef",class:[_vm.isPayerChatOpen && 'new-chat__open']}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }